module.exports = __webpack_public_path__ + "static/img/logos.4b3b1b16.png";